export default {
    myLifestyle: 'Min livsstil',
    results: 'Resultat'
};
